import { Route } from '@angular/router';
import { BreadcrumbsEnum } from './modules/shared/models/breadcrumbs.enum';
import { TrashEntityTypeEnum } from '@libs/types/src/services/enum/trash-entity-type.enum';

export const appRoutes: Route[] = [
    {
        path: 'accounting',
        data: { breadcrumb: BreadcrumbsEnum.Mado },
        loadChildren: () =>
            import('./modules/mado/mado.routes').then((m) => m.MADO_ROUTES),
    },
    {
        path: 'embed/accounting',
        data: { breadcrumb: BreadcrumbsEnum.Mado },
        loadChildren: () =>
            import('./modules/mado/mado.routes').then((m) => m.MADO_ROUTES),
    },
    {
        path: 'crm',
        data: { breadcrumb: BreadcrumbsEnum.Crm },
        loadChildren: () =>
            import('./modules/crm/crm.routes').then((m) => m.CRM_ROUTES),
    },
    {
        path: 'content',
        data: {
            visit: { skip: true },
            breadcrumb: { alias: BreadcrumbsEnum.Content },
        },
        loadChildren: () =>
            import('./modules/content/content.routes').then((m) => m.contentRoutes),
    },
    {
        path: 'embed/content',
        data: {
            visit: { skip: true },
            breadcrumb: { alias: BreadcrumbsEnum.Content },
        },
        loadChildren: () =>
            import('./modules/content/content.routes').then((m) => m.contentRoutes),
    },
    {
        path: 'databoxes',
        data: { breadcrumb: BreadcrumbsEnum.DataBoxes, disable: true },
        loadChildren: () => import('./modules/inbox/inbox.routes').then((m) => m.INBOX_ROUTES),
    },
    {
        path: 'embed/databoxes',
        data: { breadcrumb: BreadcrumbsEnum.DataBoxes, disable: true },
        loadChildren: () => import('./modules/inbox/inbox.routes').then((m) => m.INBOX_ROUTES),
    },
    {
        path: 'dms',
        data: { breadcrumb: BreadcrumbsEnum.Dms, disable: true },
        loadChildren: () => import('./modules/inbox/inbox.routes').then((m) => m.INBOX_ROUTES),
    },
    {
        path: 'embed/dms',
        data: { breadcrumb: BreadcrumbsEnum.Dms, disable: true },
        loadChildren: () => import('./modules/inbox/inbox.routes').then((m) => m.INBOX_ROUTES),
    },
    {
        path: 'email',
        data: { breadcrumb: BreadcrumbsEnum.EmailClient, disable: true },
        loadChildren: () => import('./modules/inbox/inbox.routes').then((m) => m.INBOX_ROUTES),
    },
    {
        path: 'embed/email',
        data: { breadcrumb: BreadcrumbsEnum.EmailClient, disable: true },
        loadChildren: () => import('./modules/inbox/inbox.routes').then((m) => m.INBOX_ROUTES),
    },
    {
        path: 'ab-stats',
        data: { breadcrumb: BreadcrumbsEnum.AbStats, disable: true },
        loadChildren: () => import('./modules/ab-stats/ab-stats.routes').then((m) => m.AB_STATS_ROUTES),
    },
    {
        path: 'embed/ab-stats',
        data: { breadcrumb: BreadcrumbsEnum.AbStats, disable: true },
        loadChildren: () => import('./modules/ab-stats/ab-stats.routes').then((m) => m.AB_STATS_ROUTES),
    },
    {
        path: '',
        loadChildren: () => import('./modules/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    },
    {
        path: 'examples',
        data: { breadcrumb: { skip: true } },
        loadComponent: () => import('./components/examples/examples.component').then((m) => m.ExamplesComponent),
    },
    {
        path: 'address-book',
        data: {
            trashEntityName: TrashEntityTypeEnum.ADDRESS_BOOK_CONTACT,
            breadcrumb: { label: BreadcrumbsEnum.AddressBook, alias: BreadcrumbsEnum.AddressBook },
        },
        loadComponent: () => import('./components/address-book/address-book-page/address-book-page.component').then((m) => m.AddressBookPageComponent),
    },
];
